import moment from 'moment'
/* 时间过滤器 - 日/月/年 */
export function formatDate(value) {
  return value ? moment(value).format('DD/MM/YYYY') : ''
}

export function formatDateTime(value) {
  return value ? moment(value).format('YYYY/MM/DD HH:mm') : ''
}

export function formatTime(value) {
  return value ? moment(value).format('HH:mm:ss') : ''
}

export function roleId(value) {
  switch (value) {
    case 1:
      return 'Admin'
    case 2:
      return 'Teacher'
    case 3:
      return 'Editor'
    case 4:
      return 'Parent'
    case 5:
      return 'Student'
    default:
      return ''
  }
}
export function upgradedType(value) {
  switch (value) {
    case 0:
      return '自動升級'
    case 1:
      return '手動升級'
    default:
      return '手動升級'
  }
}
export function gender(value) {
  switch (value) {
    case 0:
      return '女'
    case 1:
      return '男'
    default:
      return ''
  }
}
export function scope(value) {
  switch (value) {
    case 0:
      return '第一部分'
    case 1:
      return '第二部分'
    case 2:
      return '第三部分'
    default:
      return ''
  }
}
export function scopeEn(value) {
  switch (value) {
    case 0:
      return 'Numbers & Operations'
    case 1:
      return 'Shapes & Measurement'
    case 2:
      return 'Applications & Thinking'
    default:
      return ''
  }
}
export function paymentType(value) {
  switch (value) {
    case 0:
      return '網上付款'
    case 1:
      return '管理員開通'
    case 2:
      return '分校付款'
    case 3:
      return '升级'
    case 4:
      return '其他'
    default:
      return ''
  }
}
export function language(value) {
  switch (value) {
    case 0:
      return '中文'

    case 1:
      return '英文'

    default:
      return ''

  }
}
export function unit(value) {
  switch (value) {
    case 0:
      return '講解'

    case 1:
      return '測驗'

    default:
      return ''

  }
}
export function payStatus(value) {
  switch (value) {
    case 0:
      return '未付款'

    case 1:
      return '已付款'

    default:
      return ''

  }
}
export function isHot(value) {
  switch (value) {
    case true:
      return '是'

    case false:
      return ''

    default:
      return ''

  }
}
export function isHots(value) {
  switch (value) {
    case true:
      return '是'

    case false:
      return '否'

    default:
      return ''

  }
}
export function isRelease(value) {
  switch (value) {
    case true:
      return '已發佈'

    case false:
      return '未發佈'

    default:
      return ''

  }
}
export function isReleases(value) {
  switch (value) {
    case true:
      return '是'

    case false:
      return '否'

    default:
      return ''

  }
}
export function promote(value) {
  return value > 0 ? value : ''
}
export function questions(value) {
  switch (value) {
    case 0:
      return "選擇題";
    case 1:
      return "判斷題";
    case 2:
      return "填空題";
    case 3:
      return "算術題(定數)";
    case 4:
      return "熱點圖";
    case 5:
      return "文字拖拽";
    case 6:
      return "連線題";
    case 7:
      return "圖片拖拽題";
    case 8:
      return "算術題(變數)";
    case 9:
      return "文字拖拽(分類)";
    case 10:
      return "矩陣填空";
    default:
      return ''

  }
}

//下标转换
export function studentIndex(value) { 
  switch (value) {
    case 0:
      return "一";
    case 1:
      return "二";
    case 2:
      return "三";
    case 3:
      return "四";
    case 4:
      return "五";
    case 5:
      return "六";
    case 6:
      return "七";
    case 7:
      return "八";
    case 8:
      return "九";
    case 9:
      return "十";
    default:
      break;
  }
}

///html标签替换
export function richText(value) {
  return value !== '' ? value.replace(/<.+?>/g, '') : '';
}

///判断輸入值是否为正整數
export function isPositiveInteger(s) {

  if ((/(^[1-9]\d*$)/.test(s))) {
    return `+${s}`
  } else {
    return s
  }

}

//// 全字母大写
export function toUpperCase(value) {
  return value.slice(0, 1).toUpperCase() + value.slice(1).toLowerCase();
}
//// 全字母大写
export function replace(value) {
  return value !== '' ? value.replace(/zh/g, '') : ''
}

///设置绝对值

export function abs(value) {
  return Math.abs(value);
}

export function ellipsis(value) {
  if (!value) return '';
  if (value.length > 100) {
    return value.slice(0, 100) + '...'
  }
  return value
}

export function toFixed(value) {
  return value.toFixed(1)
}